import React, { useEffect, useRef, useState } from "react";
import mjml from "mjml-browser";

import { EmailEditor, EmailEditorProvider, Stack } from "easy-email-editor";

import { BlockManager, BasicType, JsonToMjml } from "easy-email-core";
import {
  StandardLayout,
  BlockAttributeConfigurationManager,
  DefaultPageConfigPanel,
} from "easy-email-extensions";
import { useWindowSize } from "react-use";
import "easy-email-editor/lib/style.css";
import "easy-email-extensions/lib/style.css";
import "@arco-themes/react-easy-email-theme/css/arco.css";

import { LoadingOutlined } from "@ant-design/icons";
import { PageHeader } from "@ant-design/pro-components";

import { templateData } from "../../assets/js/templateData";
import { Button, message, Spin, Modal, Alert, Input, Select } from "antd";
import {
  useLazyGetSingleEmailTemplateQuery,
  useLazyGetSiteInfoQuery,
  useSaveEmailTemplateMutation,
  useUpdateEmailTemplateMutation,
  useUploadImageMutation,
} from "./mailerApiSlice";
import { useNavigate, useParams } from "react-router-dom";
import imageCompression from "browser-image-compression";
import { useDispatch, useSelector } from "react-redux";
import { setLogin } from "../auth/authSlice";
import LoadingComponentAntD from "../../components/loadingCompAntd/LoadingComponentAntD";
import { setSiteInfor } from "../../store/slice/siteInfoSlice";

BlockAttributeConfigurationManager.add({
  [BasicType.PAGE]: () => <DefaultPageConfigPanel hideSubTitle />,
});
const fontList = [
  "Verdana",
  "Lato",
  "Montserrat",
  "Great Vibes",
  "Roboto",
  "Roboto Condensed",
  "Comic Neue",
  "Nunito",
  "Poppins",
  "Playfair Display",
  "Rubik",
  "Qwitcher Grypen",
  "Lobster",
  "Zilla Slab",
  "Caveat",
  "Merriweather",
].map((item) => ({ value: item, label: item }));
const initialValues = {
  subject: "",
  subTitle: "",
  content: BlockManager.getBlockByType(BasicType.PAGE).create({}),
};

const pageBlock = BlockManager.getBlockByType(BasicType.PAGE);

function MailEditor(props) {
  const { user_token, tempId, auth, viewType, folderName } = useParams();
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const [loaderContent, setLoaderContent] = useState("");
  const siteInfo = useSelector((state) => state.siteInfoStore?.info);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user_token && auth && viewType) {
      dispatch(
        setLogin({
          user: null,
          token: user_token,
          auth,
          viewType,
        })
      );
    }
  }, [user_token, auth, viewType]);

  const navigate = useNavigate();
  const [getSiteInfo] = useLazyGetSiteInfoQuery();

  const [category, setCategory] = useState(folderName);
  const categoryRef = useRef(null);

  const { width } = useWindowSize();
  const [myEmail, setMyEmail] = useState(initialValues);
  const [folders, setFolders] = useState();
  const [saving, setSaving] = useState(false);
  const [headersReady, setHeadersReady] = useState(false);
  const [instantUpdate, setInstantUpadate] = useState(false);

  const [saveEmailTemplate] = useSaveEmailTemplateMutation();
  const [updateEmailTemplate] = useUpdateEmailTemplateMutation();
  const [getSingleEmailTemplate] = useLazyGetSingleEmailTemplateQuery();
  const storeAuth = useSelector((state) => state.auth);

  const [uploadImage] = useUploadImageMutation();
  useEffect(() => {
    if (user_token && auth && viewType) {
      dispatch(
        setLogin({
          user: null,
          token: user_token,
          auth,
          viewType,
        })
      );
    }
  }, [user_token, auth, viewType]);

  useEffect(() => {
    if (storeAuth?.authBearer && storeAuth?.token) {
      setHeadersReady(true);
    }
  }, [storeAuth]);

  useEffect(() => {
    const fetchSiteInfo = async () => {
      try {
        const { data, error } = await getSiteInfo();
        if (data) {
          dispatch(setSiteInfor(data));
        }
        if (error) {
          console.log("site-data::", error);
        }
      } catch (error) {}
    };
    if (!headersReady) {
      fetchSiteInfo();
    }
  }, [getSiteInfo, headersReady]);

  useEffect(() => {
    if (storeAuth?.authBearer && storeAuth?.token && siteInfo?.instant_email) {
      setMyEmail((prev) => ({ ...prev, subTitle: siteInfo?.customer_name }));
    }
  }, [siteInfo, storeAuth?.authBearer, storeAuth?.token]);

  useEffect(() => {
    if (props.updating && tempId) {
      setLoaderContent("Loading");
      setLoading(true);
      (async () => {
        try {
          const resp = await getSingleEmailTemplate(tempId);
          if (resp.data) {
            if (resp.data.status) {
              let content = JSON.parse(resp?.data?.template?.template);
              setCategory(resp?.data?.template?.category_name);
              const newContent = JSON.parse(content.content);
              setMyEmail((prevState) => ({
                ...prevState,
                subject: newContent?.subject,
                scheduled: resp?.data?.token?.scheduled,
                subTitle: newContent?.subTitle,
                content: pageBlock.create(newContent.content),
              }));
              setFolders(resp?.data?.folders);
              setInstantUpadate(true);
            }
          }
          if (resp.error) {
            message.error(
              resp.error.message ??
                resp.error.data.message ??
                "Error getting Template!"
            );
          }
        } catch (error) {
        } finally {
          setTimeout(() => {
            setLoading(false);
            setLoaderContent("");
          }, 3000);
        }
      })();
    }
  }, [tempId, props, getSingleEmailTemplate]);

  // useEffect(() => {
  //   if (
  //     storeAuth?.authBearer &&
  //     storeAuth?.token &&
  //     siteInfo?.instant_email &&
  //     props.updating &&
  //     instantUpdate
  //   ) {
  //     setMyEmail((prev) => ({
  //       ...prev,
  //       subject: "",
  //       subTitle: siteInfo?.customer_name,
  //     }));
  //   }
  // }, [
  //   siteInfo,
  //   storeAuth?.authBearer,
  //   storeAuth?.token,
  //   props.updating,
  //   instantUpdate,
  // ]);

  const defaultTemp = () => {
    setMyEmail((prevState) => ({
      ...prevState,
      content: pageBlock.create(templateData),
    }));
  };

  const successMsg = (message) => {
    messageApi.open({
      type: "success",
      content: message,
    });
  };

  const errorMsg = (message) => {
    messageApi.open({
      type: "error",
      content: message,
    });
  };

  const resetTemplate = () => {
    setMyEmail({
      ...initialValues,
      subTitle: siteInfo?.instant_email
        ? siteInfo?.customer_name
        : initialValues.subTitle,
    });
  };

  function insertLinksIntoHtml(htmlContent, linkTags) {
    const headCloseTagIndex = htmlContent.indexOf("</head>");
    const linksToInsert = linkTags.join("");

    if (headCloseTagIndex === -1) {
      return linksToInsert + htmlContent;
    }

    return (
      htmlContent.slice(0, headCloseTagIndex) +
      linksToInsert +
      htmlContent.slice(headCloseTagIndex)
    );
  }

  const tempToHtml = (values) => {
    const html = mjml(
      JsonToMjml({
        data: values.content,
        mode: "production",
        context: values.content,
      }),
      {
        beautify: true,
        validationLevel: "soft",
      }
    ).html;

    const updatedHtml = html.replace(
      /(white-space-collapse:\s*)preserve(;)/g,
      "$1$2"
    );

    const fontLinks = [
      `<link href="https://fonts.googleapis.com/css2?family=Great+Vibes:wght@300;400;500;800&display=swap" rel="stylesheet" type="text/css">`,
      `<link href="https://fonts.googleapis.com/css2?family=Lato:wght@300;400;500;800&display=swap" rel="stylesheet" type="text/css">`,
      `<link href="https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;500;800&display=swap" rel="stylesheet" type="text/css">`,
      `<link href="https://fonts.googleapis.com/css2?family=Caveat:wght@300;400;500;800&display=swap" rel="stylesheet" type="text/css">`,
      `<link href="https://fonts.googleapis.com/css2?family=Zilla+Slab:wght@300;400;500;800&display=swap" rel="stylesheet" type="text/css">`,
      `<link href="https://fonts.googleapis.com/css2?family=Lobster:wght@300;400;500;800&display=swap" rel="stylesheet" type="text/css">`,
      `<link href="https://fonts.googleapis.com/css2?family=Qwitcher+Grypen:wght@300;400;500;800&display=swap" rel="stylesheet" type="text/css">`,
      `<link href="https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;800&display=swap" rel="stylesheet" type="text/css">`,
      `<link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@300;400;500;800&display=swap" rel="stylesheet" type="text/css">`,
      `<link href="https://fonts.googleapis.com/css2?family=Verdana:wght@300;400;500;800&display=swap" rel="stylesheet" type="text/css">`,
      `<link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;800&display=swap" rel="stylesheet" type="text/css">`,
      `<link href="https://fonts.googleapis.com/css2?family=Comic+Neue:wght@300;400;500;800&display=swap" rel="stylesheet" type="text/css">`,
      `<link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;800&display=swap" rel="stylesheet" type="text/css">`,
      `<link href="https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;500;800&display=swap" rel="stylesheet" type="text/css">`,
      `<link href="https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@300;400;500;800&display=swap" rel="stylesheet" type="text/css">`,
      `<link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;800&display=swap" rel="stylesheet" type="text/css">`,
    ];

    const finalHtml = insertLinksIntoHtml(updatedHtml, fontLinks);
    return finalHtml;
  };

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 24,
      }}
      spin
    />
  );

  const onSubmit = async (values, form) => {
    setSaving((prevSaving) => !prevSaving);
    const html = tempToHtml(values);

    if (props.updating) {
      try {
        setLoading(true);
        setLoaderContent("Updating");
        let body = {
          name: values?.subject,
          subject: values?.subject,
          template: JSON.stringify({
            template: html,
            content: JSON.stringify(values),
          }),
          category_name: category,
        };
        const { data, error } = await updateEmailTemplate({ body, id: tempId });

        if (data) {
          if (data.status) {
            message.success(data.message);
            if (viewType === "true" && !siteInfo?.instant_email) {
              // setTimeout(() => {
              //   window.close();
              // }, 2000);
              setTimeout(() => {
                window.location.replace(siteInfo?.back_url);
              }, 1000);
            } else if (viewType === "true" && siteInfo?.instant_email) {
              setTimeout(() => {
                window.location.replace(siteInfo?.back_url);
              }, 1000);
            } else if (category) {
              handleBack();
            } else {
              if (
                viewType === "false" &&
                !siteInfo?.instant_email &&
                !siteInfo?.email_signature
              ) {
                navigate(`/${auth}/${user_token}/false`);
              }
              if (viewType === "false" && siteInfo?.email_signature) {
                setTimeout(() => {
                  window.location.replace(siteInfo?.back_url);
                }, 1000);
              }
              if (siteInfo?.back_url_status) {
                setTimeout(() => {
                  window.location.replace(siteInfo?.back_url);
                }, 500);
              }
            }
          }
          if (!data.status) {
            message.error(data.message);
          }
        }
        if (error) {
          message.error(error.data.message);
        }
      } catch (error) {
        console.log("error::", error);
        errorMsg(error?.data?.message);
      } finally {
        setSaving(!!saving);
        setTimeout(() => {
          setLoaderContent("");
          setLoading(false);
        }, 1000);
      }
    } else {
      try {
        setLoading(true);
        setLoaderContent("Saving");
        let body = {
          name: values?.subject,
          subject: values?.subject,
          template: JSON.stringify({
            template: html,
            content: JSON.stringify(values),
          }),
          category_name: category,
        };

        const { data, error } = await saveEmailTemplate(body);

        if (data) {
          if (data.status) {
            message.success(data.message);
            navigate(
              `/${auth}/${user_token}/${viewType}/templates/${folderName}`
            );
          }
          if (!data.status) {
            message.error(data.message);
            console.log("!data.status", data);
          }
        }
        if (error) {
          errorMsg(error.data.message);
          console.log("error", error);
        }
      } catch (err) {
        console.log("err:", err);
      } finally {
        setTimeout(() => {
          setSaving(!!saving);
          setLoaderContent("");
          setLoading(false);
        }, 1000);
      }
    }
  };

  const onUploadImage = async (blob) => {
    // Check if the blob is a GIF
    if (blob.type === "image/gif") {
      // For GIFs, upload directly without compression
      const body = new FormData();
      body.append("image", blob);

      const { data, error } = await uploadImage(body);
      if (data && data?.status) {
        successMsg(data?.message);
        return `${data.path}`;
      }
      if (error) {
        errorMsg(error?.data?.message);
        console.log("Error::", error);
      }
      return null;
    } else {
      // For other images, use compression
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      try {
        const compressedFile = await imageCompression(blob, options);
        const body = new FormData();
        body.append("image", compressedFile);

        const { data, error } = await uploadImage(body);
        if (data && data?.status) {
          successMsg(data?.message);
          return `${data.path}`;
        }
        if (error) {
          errorMsg(error?.data?.message);
          console.log("Error::", error);
        }
      } catch (error) {
        console.log("catch-error::", error);
      }
    }
  };
  const handleBack = () => {
    navigate(`/${auth}/${user_token}/${viewType}/templates/${category}`);
  };
  let emailSubject = category ? `${category} / ` : "";

  return (
    <>
      {loading && <LoadingComponentAntD content={loaderContent} />}
      {contextHolder}
      {siteInfo?.note && (
        <Alert
          message={siteInfo?.note}
          type="info"
          banner
          className="alert-left-align"
        />
      )}
      <EmailEditorProvider
        data={myEmail}
        height={`${
          viewType === "true" ? "calc(100vh -  93px)" : "calc(100vh - 72px)"
        }`}
        autoComplete
        dashed={false}
        fontList={fontList}
        onUploadImage={onUploadImage}
        onSubmit={onSubmit}
        compact={true}
      >
        {({ values }, { submit }) => {
          return (
            <>
              <PageHeader
                onBack={
                  viewType === "true"
                    ? null
                    : siteInfo?.email_signature
                    ? null
                    : handleBack
                }
                title={
                  props.updating
                    ? `${emailSubject}${myEmail?.subject}`
                    : siteInfo?.instant_email
                    ? "Instant Email"
                    : siteInfo?.email_signature
                    ? "New Signature Template"
                    : "New Email Template"
                }
                extra={
                  <Stack alignment="center">
                    <span>
                      {siteInfo?.customer_name ? (
                        <>
                          Customer:{" "}
                          <b style={{ color: "red" }}>
                            {siteInfo?.customer_name}
                          </b>
                        </>
                      ) : (
                        ""
                      )}
                    </span>
                    <button
                      className="btn-header"
                      onClick={() => defaultTemp()}
                    >
                      Default Template
                    </button>
                    <button
                      className="btn-header"
                      onClick={() => resetTemplate()}
                    >
                      Reset Template
                    </button>
                    <Button
                      className="btn-header btn-header-primary"
                      type="primary"
                      disabled={!!saving}
                      onClick={() => {
                        Modal.confirm({
                          title: "Confirm",
                          content: `Are you sure you want to ${
                            props.updating
                              ? siteInfo?.instant_email
                                ? "send instant email"
                                : props.updating && siteInfo?.email_signature
                                ? "update signature"
                                : "update template"
                              : siteInfo?.instant_email
                              ? "send instant email"
                              : siteInfo?.email_signature
                              ? "save signature"
                              : "save template"
                          }?`,
                          centered: true,
                          okText: props.updating
                            ? myEmail?.scheduled === "yes" && siteInfo?.instant_email
                              ? `Schedule Email (${siteInfo?.schedule_date})`
                              : myEmail?.scheduled === "yes"
                              ? "Update Scheduled Email"
                              : siteInfo?.instant_email
                              ? "Send Email"
                              : "Update"
                            : siteInfo?.instant_email
                            ? "Send Email"
                            : "Save",
                          onOk() {
                            submit();
                          },
                          footer: (_, { OkBtn, CancelBtn }) => (
                            <>
                              <CancelBtn className="btn-header" />
                              <OkBtn type="primary" />
                            </>
                          ),
                        });
                      }}
                    >
                      <span className="mr-2" style={{ marginRight: "5px" }}>
                        {props.updating
                          ? myEmail?.scheduled === "yes" && siteInfo?.instant_email
                            ? `Schedule Email (${siteInfo?.schedule_date})`
                            : myEmail?.scheduled === "yes"
                            ? "Update Scheduled Email"
                            : siteInfo?.instant_email
                            ? "Send Email"
                            : "Update"
                          : siteInfo?.instant_email
                          ? "Send Email"
                          : "Save"}
                      </span>{" "}
                      {saving && <Spin indicator={antIcon} />}
                    </Button>
                  </Stack>
                }
              />
              <div
                style={{ width: "100%", maxWidth: "100%", overflowX: "auto" }}
              >
                <StandardLayout showSourceCode={false}>
                  <div className="email-editor-sidebar">
                    {siteInfo?.show_category_name && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                          padding: "10px 0px",
                        }}
                      >
                        {category && folders && folders.length > 0 && (
                          <div
                            style={{
                              width: "300px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              paddingRight: "10px",
                            }}
                          >
                            <label
                              style={{
                                whiteSpace: "nowrap",
                                fontSize: "14px",
                                color: "var(--color-text-2)",
                              }}
                            >
                              Folder:
                            </label>
                            <Select
                              style={{
                                width: 200,
                                marginLeft: 10,
                                textAlign: "left",
                              }}
                              onChange={(value) => setCategory(value)}
                              value={category}
                              options={folders.map((folder) => ({
                                value: folder.name,
                                label: folder.name,
                              }))}
                              placeholder="Select Folder"
                            />
                          </div>
                        )}
                      </div>
                    )}
                    <EmailEditor />
                  </div>
                </StandardLayout>
              </div>
            </>
          );
        }}
      </EmailEditorProvider>
    </>
  );
}

export default MailEditor;
